import React, { useState, useEffect, useRef, useContext } from "react";
import { ContextProvider } from '../globalContextProvider';

export default function ScrollableTable(props) {
  const { children, style, ...rest } = props;
  const { resetHeight } = useContext(ContextProvider);

  const [height, setHeight] = useState(0);
  const refDiv = useRef(null);

  useEffect(() => {
    const calculateDivHeight = () => {
      const viewportHeight = window.innerHeight;
      const divTop = refDiv.current.getBoundingClientRect().top;
      const customPaginationHeight = 80 // pagination height + adjustment
      const newHeight = viewportHeight - divTop - customPaginationHeight;
      setHeight(newHeight);
    };

    calculateDivHeight();

    window.addEventListener('resize', calculateDivHeight);
    return () => window.removeEventListener('resize', calculateDivHeight);
  }, [resetHeight]);

  return <div className="ListStyle" ref={refDiv} style={{ ...style, minHeight: 120, height: height }}>
    <table {...rest}>
      {children}
    </table>
  </div>;
}